import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LoginForm from './login/LoginForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withLastLocation } from 'react-router-last-location';
import fetchDux from '../../state/fetch-dux';
import Layout from '../ui/Layout';
import MetaTags from 'react-meta-tags';
import MetaLoader from '../ui/MetaLoader';
import queryString from 'query-string';

const getNextPath = (lastPath, lastPathSearch, clubVerify) => {

  const isShopPage = (lastPath || '').indexOf('/shop') === 0;
  const isClubInformationPage = (lastPath || '').indexOf('/club-information') >= 0;

  if (clubVerify) return '/account/club-information'
  if ((!lastPath || !isShopPage || lastPath === '/account/sign-up') && !isClubInformationPage)
    return '/shop/';
  return `${lastPath}${lastPathSearch}`;
};

class LoginRoute extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      postLogin,
      history,
      lastLocation,
      getCart,
      validateLogin,
      loginError
    } = this.props;

    const {
      pathname: lastPath,
      search: lastPathSearch
    } = lastLocation || {};

    const search = queryString.parse(lastPathSearch);
    const { waitlist: waitListClubTypeId, clubVerify:clubVerify } = search;

    const scrollToTop = () => window.scrollTo(0, 0);
    const handlePostLogin = values =>
      postLogin(values, 'login-form', null, () => {
        getCart();
        validateLogin();
        history.push(getNextPath(lastPath, lastPathSearch, clubVerify));
      });

    return (
      <Layout>
        <MetaLoader title="Login | Twomey" />
        <MetaTags>
          <title>Login | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Login | Twomey" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content="https://twomey.com/account/login" />
        </MetaTags>

        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main
              id="main"
              className="site-main shop-page nohero extra cart-page"
            >
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-6 divider-md">
                        <div className="login-box-left">
                          <h1 className="shop-large">
                            Sign in to Your Account
                          </h1>
                          <p>
                            Please login to access your address book, saved cards and member pricing.
                          </p>
                          <br />
                          <LoginForm
                            onSubmit={handlePostLogin}
                            loginError={loginError}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="login-box-right">
                          <h3>Create an Account</h3>
                          <p>
                            Check out faster, manage your profile and sign up to receive emails about new releases and exclusive offers. The best part: You only have to do it once!
                          </p>
                          <p>
                            We respect your privacy and will not share any of your personal information.
                          </p>
                          <br />
                          <div className="row">
                            <div className="col-md-8">
                              <Link
                                to={
                                  waitListClubTypeId
                                    ? `/account/sign-up?waitlist=${waitListClubTypeId}`
                                    : '/account/sign-up'
                                }
                                className="btn btn-primary btn-block"
                              >
                                Join Twomey
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <div className="row justify-content-center">
              <div className="col-md-10 text-right">
                <a href="#top" className="back-to-top" onClick={scrollToTop}>
                  Back to top
                </a>
              </div>
            </div>
          </div>
        </div>

      </Layout>
    );
  }
}

const mapState = state => {
  const { error: loginError } = state.postLogin.toJS();
  return {
    loginError
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postLogin: fetchDux.postLogin.createAction,
      getCart: fetchDux.getCart.createAction,
      validateLogin: fetchDux.validateLogin.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(withLastLocation(LoginRoute));
